module.exports = __webpack_public_path__ + "img/0Q3C6212_Foamcore_MockedUp.3af5817e.jpg";